// extracted by mini-css-extract-plugin
export default {"container":"TextInput_container__v3Vwk","title":"TextInput_title__AQ2jj"};